const styles = () => ({
  container: {
    margin: '0 auto',
    width: '100%',
    display: 'block',
    fontFamily: 'Gilroy',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '150%',
    background: '#FFFFFF',
    height: '100vh',
    color: '#484456',
  },
  hr: {
    height: '1px',
    backgroundColor: '#EBEEF3',
    border: 'none',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '16px 0px 16px 32px',
    justifyContent: 'space-between',
    '& $headerContent': {
      fontSize: '10px',
      marginRight: '20px',
    },
  },
  headerContent: {},
  main: {
    padding: '16px 0px 16px 32px',
    width: '90%',
    '& $value': {
      fontWeight: '600',
      color: '#130F26',
    },
  },
  value: {},
  headingDiv: {
    display: 'flex',
    flexDirection: 'row',
    background: '#EBEEF3',
    borderRadius: '8px',
    justifyContent: 'space-between',
    padding: '8px 16px',
    fontWeight: '600',
    marginTop: '34px',
  },

  heading: {
    fontWeight: '600',
    fontSize: '16px',
    margin: '24px 0px',
  },
  styledTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    background: '#F8F8F8',
    borderRadius: '4px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    fontSize: '10px',
    marginTop: '10px',
    color: '#484456',
  },
  boxDiv: {
    alignItems: 'flex-start',
    padding: '16px',
    background: '#FFFFFF',
    border: '1px solid #EBEEF3',
    borderRadius: '8px',
    marginTop: '24px',
  },
  boxDivContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: '400',
    fontSize: '14px',
    color: '#484456',
    width: '100%',
    marginBottom: '10px',
    '& div': {
      width: '30%',
      textAlign: 'left',
    },
    '& div:last-child': {
      textAlign: 'right',
    },
    '& $Price': {
      color: '#130F26',
      fontSize: '12px',
      textAlign: 'center',
    },
  },
  Price: {},
  boxHr1: {
    backgroundColor: '#EBEEF3',
    height: '3px',
    border: 'none',
    margin: '10px 0px',
  },
  boxHr2: {
    backgroundColor: '#EBEEF3',
    height: '8px',
    border: 'none',
    margin: '10px 0px',
  },
  fontW500: {
    fontWeight: '500',
  },
  fontW600: {
    fontWeight: '600',
  },
  fontW700: {
    fontWeight: '600',
  },
  footer: {
    width: '100%',
    marginTop: '50px',
    // height: '60px' /* Height of the footer */,
  },
  footerDiv: {
    padding: '20px 100px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // height: '60px' /* Height of the footer */,
  },
  socialDiv: {
    display: 'flex',
    flexDirection: 'column',
    '& div': {
      paddingBottom: '10px',
    },
    '&  img': {
      margin: '10px 10px 0 0',
    },
    '& a': {
      fontWeight: '400',
      fontSize: '14px',
      color: '#484456',
      textDecoration: 'none',
    },
  },
  addressDiv: {
    padding: '5px 100px',
    '& span': {
      fontWeight: '400',
      fontSize: '12px',
      color: '#484456',
      marginRight: '20px',
      borderRight: '1px solid #CED1D6',
      paddingRight: '15px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
  invoiceFooterDetails: {
    padding: '5px 30px',
    margin: 'auto',
    '& span': {
      fontWeight: '400',
      fontSize: '12px',
      color: '#484456',
      marginRight: '20px',
      borderRight: '1px solid #CED1D6',
      paddingRight: '15px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
  details: {
    marginBottom: '8px',
  },
  invoiceFooter: {
    marginTop: '100px',
  },
});
export default styles;
